import { z } from 'zod'
import { CorpusAdmission, CorpusStatus, Intent } from '../enums'
import { Id, Instant } from './primitives'

export const CORPUS_LIST_DEFAULT_LIMIT = 20
export const CORPUS_LIST_MAX_LIMIT = 100
export const CORPUS_MAX_PAGE_NUMBER = 10_000
export const CORPUS_RETIRE_REASON_MANUAL = 'retired_by_approver'

export const CorpusEntry = z.object({
  id: Id,
  conversationId: Id.nullable(),
  replyText: z.string(),
  inboundContext: z.string().nullable(),
  intent: Intent.nullable(),
  status: CorpusStatus,
  admittedVia: CorpusAdmission,
  admittedByName: z.string(),
  admittedAt: Instant,
  retiredAt: Instant.nullable(),
  retiredReason: z.string().nullable(),
})
export type CorpusEntry = z.infer<typeof CorpusEntry>

export const CorpusListQuery = z.strictObject({
  status: CorpusStatus.optional(),
  page: z.coerce.number().int().min(1).max(CORPUS_MAX_PAGE_NUMBER).default(1),
  limit: z.coerce.number().int().positive().max(CORPUS_LIST_MAX_LIMIT).default(CORPUS_LIST_DEFAULT_LIMIT),
})
export type CorpusListQuery = z.infer<typeof CorpusListQuery>
